import * as Icons from 'lucide-react';
import React from 'react';
import { LucideIconProps } from './LucideIcon.types';

export const LucideIcon = React.forwardRef<SVGSVGElement, LucideIconProps>(
  (props, ref) => {
    const { name, color, size = 6, className, preserveAspectRatio } = props;
    if (!name) return null;
    const LucideIconComponent = Icons[`${name}Icon`];
    if (!LucideIcon) {
      throw new Error(`Icon ${name} not found`);
    }
    return (
      <LucideIconComponent
        color={color}
        size={size}
        className={className}
        width={props?.style?.width || size ? `${props?.style?.width || (size * 4)}px` : undefined}
        height={props?.style?.height || size ? `${props?.style?.height || (size * 4)}px` : undefined}
        ref={ref}
        preserveAspectRatio={preserveAspectRatio}
      />
    );
  }
);

LucideIcon.displayName = 'Icon';
